import { initClient, initClientNavigation } from "rwsdk/client";
import * as Sentry from "@sentry/react";

const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute('content');
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  });
}

const { handleResponse, onHydrated } = initClientNavigation();
initClient({ handleResponse, onHydrated });